import styled from 'styled-components';
import Collapsable from 'library/components/collapsable';

export const StyledIndustryPageCardTitle = styled.div`
  align-items: flex-end;
  display: flex;
  line-height: 1.2;
  margin-bottom: 1em;
  justify-content: space-between;
  flex-wrap: wrap;

  @media (max-width: ${(props) => props.theme.screen.tablet}px) {
    justify-content: center;
  }
`;

export const StyledIndustryIconTitle = styled.div`
  display: flex;
  align-items: center;

  svg {
    height: 4em;
    margin-right: 1em;
    width: 4em;
  }
`;

export const StyledIndustryPageCardData = styled.div`
  border: 1px solid #ccc;
  border-radius: 0.25em;
  position: relative;
  margin-bottom: 1.5em;

  /* Devices less than 1024 */
  @media (max-width: ${(props) => props.theme.screen.laptop}px) {
    border: none;
  }
`;

export const StyledIndustryCard = styled.div`
  flex: 0 0 768px;
  margin-bottom: 1em;
  margin-right: 1.5em;
  padding: 2em;
  padding-top: 1em;
  width: 768px;

  @media (max-width: calc(1200px + 1em)) {
    flex: 1;
    max-width: 100%;
  }

  /* Devices less than 1024 */
  @media (max-width: ${(props) => props.theme.screen.laptop}px) {
    width: 100%;
  }
`;

export const StyledGooglePlacesInput = styled.div`
  width: 300px;
  margin-top: 1em;
`;

export const StyledCareerCards = styled.section`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const StyledTopSection = styled.div`
  display: flex;
  flex-direction: row;

  /* Devices less than 1024 */
  @media (max-width: ${(props) => props.theme.screen.laptop}px) {
    flex-direction: column;
  }
`;

export const StyledSidePanel = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledAboutHeader = styled.p`
  color: #207c9d;
  font-weight: bold;
`;

export const StyledTitleH1 = styled.h1`
  font-size: 36px;
  line-height: 1;
  margin: 0;

  small {
    font-size: 20px;
  }

  span {
    color: ${(props) => props.color};
  }
`;

export const StyledSidebarCard = styled.div`
  margin-bottom: 1em;
`;

export const StyledSidePanelContainer = styled.div`
  width: 100%;
  max-width: 420px;
`;

export const StyledCollapsable = styled(Collapsable)`
  /* Devices less than 1024 */
  @media (max-width: ${(props) => props.theme.screen.laptop}px) {
    height: 0;
    overflow: hidden;
    transition: height 0.25s ease-in-out;
    will-change: height;
  }
`;

export const StyledCollapsableContent = styled.div`
  /* Devices less than 1024 */
  @media (max-width: ${(props) => props.theme.screen.laptop}px) {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }
`;

export const StyledCollapsedIcon = styled.div`
  display: none;
  margin-left: auto;

  /* Devices less than 1024 */
  @media (max-width: ${(props) => props.theme.screen.laptop}px) {
    display: inline;
  }
`;

export const StyledCardTitle = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;

  /* Devices less than 1024 */
  @media (max-width: ${(props) => props.theme.screen.laptop}px) {
    h3 {
      margin: 0;
    }
  }
`;

export const Test = styled.svg`
  position: absolute;
  width: 5px;
  z-index: 1000;

  /* Devices less than 1024 */
  @media (max-width: ${(props) => props.theme.screen.laptop}px) {
    display: none;
  }
`;
